import React from 'react';
import { Helmet } from 'react-helmet';
import Map from '../components/Google-Maps/Map';
import '../assets/styles/Contacto.css';

export default function Contacto() {
  return (
    <div className="contact-page">
      <Helmet>
        <title>Contacto | Colegio Cristiano Le Beau Jour</title>
        <meta
          name="description"
          content="Contáctanos: teléfono, correo electrónico, horario de atención y ubicación del Colegio Cristiano Le Beau Jour en Viña del Mar. Estamos aquí para ayudarte."
        />
        <link rel="canonical" href="https://www.colegiocristianolebeaujour.cl/contacto" />
      </Helmet>

      {/* Hero */}
      <section className="contact-hero">
        <h1>Contáctanos</h1>
        <p>Estamos aquí para ayudarte. Comunícate con nosotros por el medio que prefieras.</p>
      </section>

      {/* Cards de contacto */}
      <section className="contact-cards-section">
        <div className="contact-cards-grid">
          <div className="contact-card">
            <div className="contact-card-icon">
              <i className="fas fa-phone-square-alt"></i>
            </div>
            <h3>Teléfono</h3>
            <p>(+56) 32 3241150</p>
            <a href="tel:+56323241150" className="contact-card-btn">
              Llamar ahora
            </a>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <h3>Correo Electrónico</h3>
            <p className="contact-card-email">colegio_lebeaujour@hotmail.com</p>
            <a href="mailto:colegio_lebeaujour@hotmail.com" className="contact-card-btn">
              Enviar email
            </a>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <h3>Ubicación</h3>
            <p>23 Norte Calle Dos 2039, Viña del Mar</p>
            <a
              href="https://maps.app.goo.gl/9VzbA1atufTZ1WJQ6"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card-btn"
            >
              Ver en Google Maps
            </a>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <i className="fas fa-clock"></i>
            </div>
            <h3>Horario de Atención</h3>
            <p>Lunes a Viernes</p>
            <p className="contact-card-schedule">08:00 - 17:00 hrs</p>
          </div>
        </div>
      </section>

      {/* Mapa */}
      <section className="contact-map-section">
        <h2>Encuéntranos en Viña del Mar</h2>
        <div className="contact-map-wrapper">
          <Map />
        </div>
      </section>

      {/* Redes sociales */}
      <section className="contact-social-section">
        <h2>Síguenos en nuestras Redes Sociales</h2>
        <div className="contact-social-icons">
          <a
            href="https://www.facebook.com/CollegeLeBeauJour/?locale=es_LA"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook del colegio"
            className="contact-social-icon"
          >
            <i className="fab fa-facebook-f"></i>
          </a>
          <a
            href="https://www.instagram.com/colegiolebeaujour/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram del colegio"
            className="contact-social-icon"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </section>
    </div>
  );
}
